import T from "utils/T";

const ABNORMAL_GLOCOSE_TYPES = {
  H: T('고혈당'),
  N: T('정상'),
  L: T('저혈당'),
  V: T('변동혈당'),
};

export default ABNORMAL_GLOCOSE_TYPES;